//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import CompensationFundForm from '@/views/HumanResource/HrCompensationFund/Compensation_fund'

//
export default {
    path: 'compensation_fund',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'compensation-fund-form',
            component: CompensationFundForm,
        },
    ],
    meta: {
        title: 'Caja de compensación',
    },
}
